import React, { Component } from 'react';
import classNames from 'classnames';
import MoVeInMobileHeader from '../../../../../common/components/MoVeInMobileHeader';
import MoVeInMobileFooter from '../../../../../common/components/MoVeInMobileFooter';
import WelcomeHero from '../WelcomeHero';
import InstallersSection from '../InstallersSection';
import AssistanceStrip from '../AssistanceStrip';

import './MobileWelcome.css';

class MobileWelcome extends Component {
  onContactusClick = () => {
    window.open('tel:+393459782557', '_blank');
    return null;
  };

  render() {
    const { dataCollection } = this.props;

    const cls = classNames({
      MobileWelcome: true
    });

    return (
      <div className={cls}>
        <MoVeInMobileHeader />
        <WelcomeHero onIdAdesioneSubmit={this.props.onIdAdesioneSubmit} />
        <InstallersSection dataCollection={dataCollection} />
        <AssistanceStrip onContactusClick={this.onContactusClick} onEmailClick={this.props.onEmailClick} />
        <MoVeInMobileFooter />
      </div>
    );
  }
}

export default MobileWelcome;
